class ResponsiveImages {
    images = new WeakMap();

    constructor() {
    }

    init() {
        const elements = this.getResponsiveElements();
        elements.forEach((el) => {
            const arr = JSON.parse(el.dataset.responsive);
            if (arr.length == 0) return;
            const size = this.getAppropriateSize(el, arr);
            this.setImage(el, size.url);
            this.images.set(el, {
                size: size,
            });
        });
    }

    getResponsiveElements() {
        const elements = document.body.querySelectorAll('[data-responsive]');
        return [...elements];
    }

    getAppropriateSize(el, array) {
        const containerWidth = el.offsetWidth;
        for (let i = 0; i < array.length; i++) {
            const obj = array[i];
            // if the image is smaller than the container then continue checking
            if (obj.width < containerWidth) continue;
            // if image is bigger than container, then return
            return obj;
        }
        // no image was big enough
        // fall back on biggest
        return array[array.length - 1];
    }

    setImage(el, url) {
        if (el instanceof HTMLImageElement) {
            el.src = url;
        } else {
            el.style.backgroundImage = `url(${url})`;
        }
    }
}

export default ResponsiveImages;
